import { Component, inject } from '@angular/core';
import { CdkTrapFocus } from '@angular/cdk/a11y';
import { MatIconModule } from '@angular/material/icon';

import { Notification, type NotificationTone } from 'app/shared/services/notification';

const ICON_BY_TONE: Record<NotificationTone, string> = {
  success: 'check_circle',
  error: 'error',
  warning: 'warning',
  info: 'info',
};

@Component({
  selector: 'app-notification-center',
  imports: [CdkTrapFocus, MatIconModule],
  styleUrl: './notification-center.scss',
  templateUrl: './notification-center.html',
})
export class NotificationCenter {
  private readonly notification = inject(Notification);
  protected readonly messages = this.notification.messages;
  protected readonly confirmation = this.notification.confirmation;

  /**
   *
   * Función utilizada para obtener el icono asociado al tono de una notificación
   */
  iconFor(tone: NotificationTone): string {
    return ICON_BY_TONE[tone];
  }

  /**
   *
   * Función utilizada para descartar una notificación por su identificador
   */
  dismiss(id: number): void {
    this.notification.dismiss(id);
  }

  /**
   *
   * Función utilizada para responder la confirmación pendiente con la decisión del usuario
   */
  answerConfirmation(confirmed: boolean): void {
    this.notification.answerConfirmation(confirmed);
  }
}
